export const fetch = 'FETCH-SPONSORSHIPS'
export const fetched = 'FETCHED-SPONSORSHIPS'
export const error = 'ERROR-SPONSORSHIPS'
export const reset = 'RESET-SPONSORSHIPS'
export const insert = 'INSERT-SPONSORSHIPS'
